import { QUICK_START_LANGUAGE_PRIORITY } from '../github.const'

export function pickDefaultQuickStartLanguage(languageKeys: string[]): string {
  const set = new Set(languageKeys.map((k) => k.toLowerCase()))
  for (const candidate of QUICK_START_LANGUAGE_PRIORITY) {
    if (set.has(candidate)) return candidate
  }
  return [...languageKeys].toSorted((a, b) => a.localeCompare(b))[0] ?? 'default'
}
